export function SET(state, payload) {
  state.admins = payload.data;
}